export enum EstimateTableActionEnum {
    Open,
    ChangeData,
    ShowHistory,
    OpenKs6,
    Delete,
}

export enum EstimateUserTypeEnum {
    Undefined,
    Contractor,
    Estimator,
    Supervisor,
    ProjectManager,
}
